import { RefObject, useEffect } from 'react';

interface UseCloseKeyboardOnScrollOptions {
    disabled?: boolean;
}

/**
 * Закрывает виртуальную клавиатуру при скроле
 * @param inputRef - Ссылка на элемент инпута
 * @param options - Опции хука
 * @param options.disabled - Отключить закрытие клавиатуры при скроле
 */
export function useCloseKeyboardOnScroll<TElement extends HTMLElement>(
    inputRef: RefObject<TElement>,
    options?: UseCloseKeyboardOnScrollOptions,
): void {
    useEffect(() => {
        if (options?.disabled) {
            return;
        }

        let touchStartY = 0;
        const SCROLL_THRESHOLD = 5;

        const handleTouchStart = (e: TouchEvent) => {
            touchStartY = e.touches[0].clientY;
        };

        const handleTouchMove = (e: TouchEvent) => {
            const touchCurrentY = e.touches[0].clientY;
            const deltaY = Math.abs(touchCurrentY - touchStartY);

            if (deltaY > SCROLL_THRESHOLD && document.activeElement === inputRef.current) {
                inputRef.current?.blur();
            }
        };

        document.addEventListener('touchstart', handleTouchStart, { passive: true });
        document.addEventListener('touchmove', handleTouchMove, { passive: true });

        return () => {
            document.removeEventListener('touchstart', handleTouchStart);
            document.removeEventListener('touchmove', handleTouchMove);
        };
    }, [inputRef, options?.disabled]);
}
